class loadingButton extends HTMLElement {
  constructor() {
    super();
    this.url = '';
    this.totalProducts = 0;
    this.loadedProducts = 0;
    this.progressBar = this.querySelector('.progress-bar');
    if (this.progressBar) this.progressBar.value = this.loadedProducts;
    this.resultCount = this.querySelector('.result-count');
    this.automaticLoading = this.getAttribute('automatic-loading');
    this.loadButtonContainer = this.closest('.pagination-wrapper');
    this.loadButton =  this.querySelector('button');
    this.productContainer =  document.querySelector('#product-grid');
    this.articleContainer =  document.querySelector('#article-grid');
    this.vanillaPagination =  document.querySelector('#pagination');
    this.loadButton.addEventListener(
      'click',
      this.loadMore.bind(this)
    );

    // loading observer
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25
    };
    this.observer = new IntersectionObserver(this.handleIntersection, options);
  }

  connectedCallback() {
    if (this.automaticLoading === 'true' ) {
      this.observer.observe(this.loadButton);
    }
    this.loadedProducts = parseInt(this.loadButton.getAttribute('data-loaded-products-total'));
    this.totalProducts = parseInt(this.loadButton.getAttribute('data-total-results-count'));
    this.updateProgress();
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest('loading-button').loadMore();
      }
    });
  }

  loadMore() {
    this.url = document.querySelector('.pagination-wrapper a.pagination__item--next').href;
    this.loadButton.classList.add('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.fetchItems(this.url);
  }

  fetchItems(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        if (url.includes("blog")) this.renderArticleGrid(html);
        else this.renderProductGrid(html);
        this.renderNewNavigation(html);
        this.loadingButtonChecker();
        this.updateProgress();
      });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
    this.productContainer.innerHTML = this.productContainer.innerHTML + newPage;
    this.loadedProducts = this.productContainer.querySelectorAll('.product').length;
  }

  renderArticleGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('article-grid').innerHTML
    this.articleContainer.innerHTML = this.articleContainer.innerHTML + newPage;
    this.loadedArticles = this.articleContainer.querySelectorAll('.article').length;
  }

  renderNewNavigation(html) {
    this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination').innerHTML;
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
    if (document.querySelectorAll('.pagination-wrapper a.pagination__item--next').length === 0) {
      this.loadButtonContainer.classList.add('hidden');
    }
  }

  updateProgress() {
    let progress = (this.loadedProducts / this.totalProducts) * 100;
    if (this.progressBar) this.progressBar.setAttribute("style", "--progress:" + `${progress}` + "%");
    this.resultCount.textContent = `Showing ${this.loadedProducts} of ${this.totalProducts}`;
  }
}

customElements.define('loading-button', loadingButton);